import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of one change request; it moved to /approvals/$requestId. */
export const Route = createFileRoute('/_app/changes/$requestId')({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: '/approvals/$requestId',
      params: { requestId: params.requestId },
      search: location.search as never,
      replace: true,
    });
  },
});
